<style scoped>
.Title {
}

.Title-big span {
  font-family: 'GothamBold';
  font-size: 32px;
  line-height: 42px;
  color: #000000;
  padding: 15px 0;
}

.Title-medium span {
  font-family: 'GothamBold';
  font-size: 20px;
  line-height: 30px;
  color: #000000;
  padding: 10px 0;
}

.Title-small span {
  color: #00AEB0;
  font-size: 12px;
  line-height: 30px;
  font-family: 'GothamBook';
}

.Title-uppercase span {
  text-transform: uppercase;
}
</style>

<template>
  <div class="Title" :class="class_root">
    <span><Animation><slot></slot></Animation></span>
  </div>
</template>

<script>

// -----

export default {
  props: {
    type: {
      default: () => 'big' // big | medium | small
    },
    uppercase: {
      default: () => true
    },
  },
  computed: {
    class_root() {
      const classes = []
      if (this.type === 'big') classes.push('Title-big')
      if (this.type === 'medium') classes.push('Title-medium')
      if (this.type === 'small') classes.push('Title-small')
      if (this.uppercase) classes.push('Title-uppercase')
      return classes
    }
  },
}
</script>
